module.exports = __webpack_public_path__ + "img/kort-24.753a34f6.jpg";